const _getModules = (() => {
  let cache

  return async () => {
    if (cache) return cache

    const [{ useCustomerStore }, { useFeaturesStore }] = await Promise.all([
      import('@/stores/customer'),
      import('@/stores/features')
    ])
    cache = { customer: useCustomerStore(), features: useFeaturesStore() }
    return cache
  }
})()

const customerGuardV2 = async (_t, _f, next) => {
  const { customer } = await _getModules()

  await customer.waitUntilPending()

  if (!customer.customerSoftLoggedIn) {
    const currentUrl = new URL(window.location.href)
    const redirectParam = currentUrl.searchParams.get('redirect')
    const loginUrl = redirectParam
      ? `/auth/v2/login?redirect_uri=${encodeURIComponent(redirectParam)}`
      : `/auth/v2/login?redirect_uri=${_t?.fullPath || '/'}`

    next(loginUrl)
    return
  }

  next()
}

const adminGuard = async (_t, _f, next) => {
  const { customer } = await _getModules()

  await customer.waitUntilPending()

  if (customer.customerIsAdmin) {
    next()
    return
  }

  return next({ name: 'error' })
}

export { adminGuard, customerGuardV2 }
